export const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
}
export const tailLayout = {
  wrapperCol: { offset: 4, span: 16 },
}
